import { motion } from "framer-motion";

const services = [
    { name: "Videopodcast", detail: "Formatos episódicos pensados para construir comunidad." },
    { name: "Social Content", detail: "Contenidos verticales con voz, ritmo y autoría." },
    { name: "Branded Content", detail: "Piezas narrativas que dejan huella en marcas." },
    { name: "Documentary", detail: "Historias reales con mirada cinematográfica." },
    { name: "Commercial", detail: "Campañas con dirección de arte y dirección de cine." },
];

export default function Services() {
    return (
        <section id="services" data-testid="services-section" className="px-6 md:px-12 py-24 md:py-48 border-t border-white/5">
            <div className="grid grid-cols-12 gap-6 mb-16 md:mb-28">
                <p className="col-span-12 md:col-span-2 text-[11px] tracking-[0.32em] uppercase text-white/45 mt-2">
                    01 — Services
                </p>
                <h2 className="col-span-12 md:col-span-10 font-display tracking-tightest leading-[0.82] text-5xl md:text-7xl lg:text-[110px]">
                    Lo que hacemos
                    <br />
                    <span className="text-white/45">cuando algo</span>
                    <br />
                    <span className="text-[color:var(--midi-accent-strong)]">merece contarse.</span>
                </h2>
            </div>

            <ul className="border-t border-white/10">
                {services.map((s, i) => (
                    <ServiceRow key={s.name} service={s} index={i} />
                ))}
            </ul>
        </section>
    );
}

function ServiceRow({ service, index }) {
    return (
        <motion.li
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: index * 0.05 }}
            className="group border-b border-white/10 py-8 md:py-12"
            data-testid={`service-row-${index}`}
        >
            <div className="grid grid-cols-12 items-baseline gap-4">
                <span className="col-span-2 md:col-span-1 text-white/30 text-sm font-light tabular-nums">
                    {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="col-span-10 md:col-span-7 font-display tracking-tightest text-3xl md:text-6xl lg:text-7xl leading-[0.78] transition-colors duration-700 group-hover:text-[color:var(--midi-accent-strong)]">
                    {service.name}
                </h3>
                <p className="col-start-3 md:col-start-9 col-span-10 md:col-span-4 text-white/55 font-light text-sm md:text-base leading-relaxed mt-3 md:mt-0">
                    {service.detail}
                </p>
            </div>
        </motion.li>
    );
}
